import { DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import { useCallback, useState } from "react";

import { fromPickerDate, toPickerDate } from "@/utils/picker-date";

import { InputContainer } from "../InputContainer";

type DatePickerControlProps = {
  value?: Date | string;
  label?: string;
  alignLabel?: boolean;
  onChange: (date?: Date) => void;
  type?: "date" | "dateTime";
  disabled?: boolean;
  maxDate?: Date | string;
  minDate?: Date | string;
  inChart?: boolean;
  validation?: boolean;
};

function DatePickerControl({
  value,
  label,
  alignLabel,
  onChange,
  disabled,
  type = "date",
  maxDate,
  minDate,
  inChart,
}: DatePickerControlProps) {
  // Values are instants; the pickers show them in Paris time.
  const [dateValue, setDateValue] = useState<Date | null>(() => toPickerDate(value));

  const handleDateChange = useCallback(
    (newDate: Date | null) => {
      const instant = fromPickerDate(newDate);
      setDateValue(instant ? newDate : null);
      onChange(instant ?? undefined);
    },
    [onChange]
  );

  const commonProps = {
    disabled,
    value: dateValue,
    onChange: handleDateChange,
    minDate: toPickerDate(minDate) ?? undefined,
    maxDate: toPickerDate(maxDate) ?? undefined,
    slotProps: {
      actionBar: {
        actions: ["clear" as const],
      },
      textField: {
        variant: "standard" as const,
        fullWidth: true,
      },
    },
  };

  return (
    <InputContainer alignLabel={alignLabel} label={label} className={inChart ? "inChart" : ""}>
      {type === "date" ? (
        <DatePicker {...commonProps} views={["month", "day", "year"]} />
      ) : (
        <DateTimePicker
          {...commonProps}
          ampm={false}
          views={["month", "day", "year", "hours", "minutes"]}
        />
      )}
    </InputContainer>
  );
}

export default DatePickerControl;
